export class UpdateProjectHasCertificationDto {}
